import { render, staticRenderFns } from "./RequestPBK.vue?vue&type=template&id=03ba8a2e&"
import script from "./RequestPBK.vue?vue&type=script&lang=js&"
export * from "./RequestPBK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports